import { setTenantId } from "./customerSlice";

/**
 * Take the attribute from preselectedTenantId, make sure to commit it to the Redux
 * state, in "tenantId", then delete it from the object.
 */
const commitPreselectedTenantId = (customerData, reduxApi) => {
  const preselectedTenantId = customerData?.preselectedTenantId;
  if (preselectedTenantId) {
    reduxApi.dispatch(setTenantId(preselectedTenantId));
    delete customerData.preselectedTenantId;
  } else if (Object.hasOwn(customerData, "preselectedTenantId")) {
    delete customerData.preselectedTenantId;
  }
};

export default commitPreselectedTenantId;
